module.exports = __webpack_public_path__ + "emojiIcon.png?78d70028296c06ba402c5381f9935860";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/emojiIcon.png
// module id = 50
// module chunks = 0